import { FC, memo } from 'react';
import { IS_SCREEN_SHARING_SUPPORTED } from '@/constants/devices';
import { useIsMobile } from '@/hooks/useIsMobileSm';
import { selectAppointmentIsAppointment } from '@/store/features/appointment/selectors';
import { useAppSelector } from '@/store/hooks';
import AppointmentToggleButton from '../AppointmentToggleButton';
import AudioToggleButton from '../AudioToggleButton';
import ChatToggleButton from '../ChatToggleButton';
import EndCallToggleButton from '../EndCallToggleButton';
import ScreenShareToggleButton from '../ScreenShareToggleButton';
import SettingsToggleButton from '../SettingsToggleButton';
import VideoToggleButton from '../VideoToggleButton';
import { StyledRoomControls, StyledRow } from './styled';

const RoomControls: FC = () => {
  const isMobile = useIsMobile();

  const isAppointment = useAppSelector(selectAppointmentIsAppointment);

  const renderRight = () => (
    <>
      <SettingsToggleButton />
      {isAppointment && <AppointmentToggleButton />}
    </>
  );

  return (
    <StyledRoomControls>
      {!isMobile && <StyledRow />}
      <StyledRow>
        <AudioToggleButton />
        <VideoToggleButton />
        {IS_SCREEN_SHARING_SUPPORTED && <ScreenShareToggleButton />}
        <ChatToggleButton />
        {isMobile && renderRight()}
        <EndCallToggleButton />
      </StyledRow>
      {!isMobile && (
        <StyledRow>
          {renderRight()}
        </StyledRow>
      )}
    </StyledRoomControls>
  );
};

export default memo(RoomControls);